<td>
<div class="notification-title unread">
    <div class="bullet bullet-blue"></div><span><a [href]="downloadUrl" target="_blank">{{ displayTitle }}</a></span>
</div>
<div class="notification-date">{{ reportDate }}</div>
</td>
